import React, { memo } from 'react'

import {
  arrayOf, func, shape, string,
} from 'prop-types'

import { EMPTY_ARRAY, NOOP } from 'Utils/stableDefaults'

import Categories from './Components/Categories/Categories'
import Search from './Components/Search/Search'
/* import SortDropdown from './Components/SortDropdown/SortDropdown' */

// Search + category chip row shared by the community galleries (3D models,
// images). Controlled: the host owns the filter values. The host also names the
// row through `className` so the flex sizing of the chips and the search input
// stays with the consuming panel's SCSS (see _community_gallery_panel.scss).
function GalleryFilters({
  className = '',
  searchQuery = '',
  onSearchChange = NOOP,
  searchPlaceholder = 'Search',
  category = '',
  categories = EMPTY_ARRAY,
  onCategoryChange = NOOP,
  morePlaceholder = 'More',
}) {
  return (
    <div className={className}>
      <Search value={searchQuery} onChange={onSearchChange} placeholder={searchPlaceholder} />
      <Categories
        categories={categories}
        selected={category}
        onChange={onCategoryChange}
        morePlaceholder={morePlaceholder}
      />
      {/* Hiding them for now until we have enough models/data */}
      {/* <div className="community-gallery-panel__filters-divider" /> */}
      {/* <SortDropdown value={sortOrder} options={sortOptions} onChange={onSortChange} /> */}
    </div>
  )
}

GalleryFilters.propTypes = {
  className: string,
  searchQuery: string,
  onSearchChange: func,
  searchPlaceholder: string,
  category: string,
  categories: arrayOf(shape({
    name: string.isRequired,
    value: string.isRequired,
  })),
  onCategoryChange: func,
  morePlaceholder: string,
}

export default memo(GalleryFilters)
